export interface HTMLStripProps {
  html: string;
}

/**
 * Static markdown / HTML strip. Maps to manifest chart_type=html_strip.
 * Used for explainer text between widgets. The renderer is expected to
 * pre-sanitize the HTML upstream; this component does not sanitize.
 */
export default function HTMLStrip(props: HTMLStripProps) {
  return (
    <div
      style={{
        padding: "16px 20px",
        color: "var(--text-muted)",
        fontSize: 14,
        lineHeight: 1.55,
      }}
      dangerouslySetInnerHTML={{ __html: props.html }}
    />
  );
}
